export class TriggerStats {
  atg: {min: number; max: number; avg: number};

  constructor(v: Partial<TriggerStats>) {
    this.atg = {min: v.atg?.min, max: v.atg?.max, avg: v.atg?.avg};
  }
}
